var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "demo-image" },
        [
          _c(
            "el-upload",
            {
              attrs: {
                action: _vm.filesUploadApi + "?name=test",
                headers: _vm.headers,
                "file-list": _vm.fileList,
                "on-success": _vm.handleSuccess,
                "list-type": "picture-card",
                multiple: "",
                "on-remove": _vm.handleRemove,
              },
            },
            [_c("i", { staticClass: "el-icon-plus" })]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { visible: _vm.dialogVisibles },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisibles = $event
                },
              },
            },
            [
              _c("img", {
                attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
              }),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }